// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1wRer","actions":"GroupTable_actions__2oTK9","deleteModalFooter":"GroupTable_deleteModalFooter__XEABE"};